@if (climaticData()?.bulk_density || climaticData()?.pressure_resistance || climaticData()?.water_absorption || climaticData()?.acid_resistance || climaticData()?.frost_resistance || climaticData()?.chemical_formula) {
  <section class="product-climatic" id="climaticCharacteristics">
    <h3 class="product-climatic__title">
      {{ 'products.specifications' | translate }}
    </h3>
    <div class="product-climatic__content">
      <!-- climatic properties items -->
      <div class="climatic-properties">
        <ul class="climatic-properties__group">
          @if (climaticData()?.bulk_density?.value != null && climaticData()?.bulk_density?.value !== '') {
            <li class="property-item">
              <h4 class="property-item__name">
                {{ 'products.density' | translate }}
                @if (climaticData()?.bulk_density?.unit) {
                  <span class="property-item__unit">
                    (
                    {{ 'enums.measurements.' + climaticData()?.bulk_density?.unit | translate }}
                    )</span>
                }
              </h4>
              <p class="property-item__value">
                {{ climaticData()?.bulk_density?.value }}
              </p>
            </li>
          }
          @if (climaticData()?.pressure_resistance) {
            <li class="property-item">
              <h4 class="property-item__name">
                {{ 'products.pressureResistance' | translate }}
              </h4>
              <p class="property-item__value">
                <span>{{ (climaticData()?.pressure_resistance ?? '') | translate }}</span>
              </p>
            </li>
          }
          @if (climaticData()?.water_absorption) {
            <li class="property-item">
              <h4 class="property-item__name">
                {{ 'products.waterAbsorption' | translate }}
              </h4>
              <p class="property-item__value">
                <span>{{ (climaticData()?.water_absorption ?? '') | translate }}</span>
              </p>
            </li>
          }
        </ul>

        @if (climaticData()?.acid_resistance) {
          <div class="climatic-properties__other-property">
            <h4 class="item-name">
              {{ 'products.acidResistance' | translate }}
            </h4>
            <p class="item-value">
              {{ climaticData()?.acid_resistance }}
            </p>
          </div>
        }

        @if (climaticData()?.frost_resistance) {
          <div class="climatic-properties__other-property">
            <h4 class="item-name">
              {{ 'products.frostResistance' | translate }}
            </h4>
            <p class="item-value">
              <span>{{ (climaticData()?.frost_resistance ?? '') | translate }}</span>
            </p>
          </div>
        }
      </div>

      @if (climaticData()?.chemical_formula) {
        <div class="climatic-formula">
          <h4 class="climatic-formula__name">
            {{ 'products.chemicalFormula' | translate }}
          </h4>
          <p class="climatic-formula__value">
            {{ climaticData()?.chemical_formula }}
          </p>
        </div>
      }
    </div>
  </section>
}
